module.exports = __webpack_public_path__ + "static/media/minus.3746cf28.svg";